import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Airport } from '../models/airport.model';
import { CloseDialog } from '../../shared/dialog-close/dialog-close';
import { FormGroup, FormControl, Validators } from '../../../../node_modules/@angular/forms';
import {BusinessManagerService} from '../../shared/user/business-manager.service';
import {Business} from '../../business/models/business.model';
import {NewBusiness} from '../../business/models/new-business-model';
import {BusinessTag} from '../../business/models/business-tag.model';

@Component({
  selector: 'app-add-business-dialog',
  templateUrl: './add-business-dialog.component.html',
  styleUrls: ['./add-business-dialog.component.scss']
})
export class AddBusinessDialogComponent implements OnInit {

  airport: Airport;
  facilityType: string;
  formGroup: FormGroup;
  businessTags: BusinessTag[];
  isLoading = false;
  constructor(private _dialogRef: MatDialogRef<AddBusinessDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private _businessManagerService: BusinessManagerService) {
    this.airport = data.airport;
    this.facilityType = data.facilityType;
  }

  ngOnInit() {
    this.formGroup = new FormGroup({
      name: new FormControl('', [Validators.required])
    });
    this._dialogRef.backdropClick().subscribe(() => {
      const CLOSE_DIALOG = new CloseDialog();
      CLOSE_DIALOG.cancelButtonClicked = true;
      this._dialogRef.close(CLOSE_DIALOG);
    });
  }

  async onSubmit() {
    this.businessTags = [];
    if (this.facilityType === 'FLYING CLUB') {
      this.businessTags.push(Object.assign(new BusinessTag(), {tagName: 'Flying Club'}));
      this.businessTags.push(Object.assign(new BusinessTag(), {tagName: 'Flying Club::Non-Equity Club'}));
    }
    const CLOSE_DIALOG = new CloseDialog();
    let newBusiness: Business;
    const BUSINESS = Object.assign(new NewBusiness(), {
      name: this.formGroup.controls['name'].value,
      facilityType: this.facilityType,
      airport: this.airport,
      businessTags: this.businessTags,
      userAdded: false
    });

    // api call
    try {
      this.isLoading = true;
      newBusiness = await this._businessManagerService.createBusiness(BUSINESS);
      this.isLoading = false;
      CLOSE_DIALOG.payload = newBusiness.id;
      CLOSE_DIALOG.success = true;
    } catch (e) {
      CLOSE_DIALOG.success = false;
      if (e) {
        CLOSE_DIALOG.error = e;
      }
    }
    this._dialogRef.close(CLOSE_DIALOG);
  }
}

